export default __webpack_public_path__ + "static/media/01.2423a51e.jpg";